/**
 * NPF Nutrition - Délais popups
 * Cookies : 5 secondes après chargement
 * Newsletter (Shopify Forms) : 30 secondes, ou après fermeture du bandeau cookies
 */
(function () {
  'use strict';

  var COOKIE_DELAY = 5000;
  var NEWSLETTER_DELAY = 30000;
  var STYLE_ID = 'npf-popup-delay-styles';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      'html.npf-hide-cookies .shopify-pc__banner,',
      'html.npf-hide-cookies #shopify-pc__banner__dialog,',
      'html.npf-hide-cookies .shopify-pc__prefs {',
      '  display: none !important;',
      '  visibility: hidden !important;',
      '  opacity: 0 !important;',
      '  pointer-events: none !important;',
      '}',
      'html.npf-hide-newsletter [id^="app-embed-container-"],',
      'html.npf-hide-newsletter shopify-forms-embed {',
      '  display: none !important;',
      '  visibility: hidden !important;',
      '  opacity: 0 !important;',
      '  pointer-events: none !important;',
      '}'
    ].join('\n');

    (document.head || document.documentElement).appendChild(style);
  }

  function isCookieBannerVisible() {
    var banner = document.querySelector('.shopify-pc__banner');
    if (!banner) return false;

    var style = window.getComputedStyle(banner);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      parseFloat(style.opacity || '1') > 0.01 &&
      banner.offsetParent !== null
    );
  }

  function showCookies() {
    document.documentElement.classList.remove('npf-hide-cookies');
  }

  function showNewsletter() {
    document.documentElement.classList.remove('npf-hide-newsletter');
  }

  function scheduleNewsletter() {
    if (!document.documentElement.classList.contains('npf-hide-newsletter')) return;

    if (isCookieBannerVisible()) {
      var observer = new MutationObserver(function () {
        if (!isCookieBannerVisible()) {
          observer.disconnect();
          showNewsletter();
        }
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
      });
      return;
    }

    showNewsletter();
  }

  function startTimers() {
    window.setTimeout(showCookies, COOKIE_DELAY);
    window.setTimeout(scheduleNewsletter, NEWSLETTER_DELAY);
  }

  injectStyles();
  document.documentElement.classList.add('npf-hide-cookies', 'npf-hide-newsletter');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startTimers);
  } else {
    startTimers();
  }
})();
